var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20V9.8C4 8.11984 4 7.27976 4.32698 6.63803C4.6146 6.07354 5.07354 5.6146 5.63803 5.32698C6.27976 5 7.11984 5 8.8 5H13M4 20L2 18M4 20L6 18M13 5C13 5.55228 13.4477 6 14 6C14.5523 6 15 5.55228 15 5C15 4.44772 14.5523 4 14 4C13.4477 4 13 4.44772 13 5ZM4 13L13 13M13 13C13 13.5523 13.4477 14 14 14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12C13.4477 12 13 12.4477 13 13ZM18.5 3.00003L19.5435 2.37518V7.37518M21.0217 15.2501L18.1522 15.2498C19.4565 13.8957 21.1374 12.1452 20.5 11C19.8626 9.8813 18.1522 10.375 18.1522 11.625",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/auto#.8728d36a91d0015fa48bff0850fc82e7.svg";
export { ForwardRef as ReactComponent };